import { render, staticRenderFns } from "./ManufacturerCreate.vue?vue&type=template&id=0f8d20a5&"
import script from "./ManufacturerCreate.vue?vue&type=script&lang=js&"
export * from "./ManufacturerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports